import React, { type ReactNode } from 'react';
import { cn } from '@chapche/ui';
import LocaleSwitcher from './LocaleSwitcher';

type LocaleAffixedFieldProps = {
    locale: string;
    onLocaleChange: (locale: string) => void;
    children: ReactNode;
    className?: string;
};

/**
 * Shared atom for “text for a locale”: children input + RU▾ chip (same as property name).
 */
const LocaleAffixedField = ({
    locale,
    onLocaleChange,
    children,
    className,
}: LocaleAffixedFieldProps) => (
    <div
        className={cn(
            'main__subtitle product__form-label product__form_lowercase item__name relative',
            className,
        )}
    >
        <div className="locale__select locale__select_add">
            <LocaleSwitcher localeCode={locale} notifyListener={onLocaleChange} />
        </div>
        {children}
    </div>
);

export default LocaleAffixedField;
